// Keep in sync with benchling/dev_platform/constants.py
export enum AvailabilityToShow {
  LA = 'la',
  GA = 'ga',
  NOT_AVAILABLE = 'not-available',
}

export enum AllowedVersions {
  V2_ALPHA = 'v2-alpha',
  V2_BETA = 'v2-beta',
  V2 = 'v2',
  V3_DRAFT = 'v3-draft',
  // Local-only developer playground; only rendered when DEPLOY_ENVIRONMENT === 'development'.
  V3_INTERNAL = 'v3-internal',
}

// Keep in sync with V3_API_REFERENCE_URL in benchling/dev_platform/constants.py
export const V3_DOCS_URL = 'https://docs.benchling.com/docs/api';

// The developer docs site only publishes GA endpoints, so only the GA reference for these versions links there.
// TODO(BNCH-178328): add v2-alpha once its spec is published to and synced with the developer docs site.
// Keep in sync with API_REFERENCE_URL_BY_VERSION in benchling/dev_platform/constants.py
export const V2_DOCS_URL = 'https://docs.benchling.com/docs/api/v2';
export const V2_BETA_DOCS_URL = 'https://docs.benchling.com/docs/api/v2-beta';
export const DOCS_URL_BY_VERSION: Partial<Record<string, string>> = {
  [AllowedVersions.V2]: V2_DOCS_URL,
  [AllowedVersions.V2_BETA]: V2_BETA_DOCS_URL,
};
